<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> مدیریت آگهی&zwnj;ها </span>

    </div>

</div>

<main style="direction: rtl;" class="px-2">

    <div [formGroup]="mdl_Search" class="border border-2 container-fluid row gx-2 gy-2 mt-3 p-2">

        <!-- جستجو -->

        <div class="col-12 col-md-7">

            <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter_Result($event.target)">

        </div>

        <!-- منتشر شده -->

        <div class="form-check form-switch m-0 d-flex align-items-center col-6 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="tiPublishStatus" formControlName="tiPublishStatus">
        
            <label class="form-check-label pointer text-muted me-2" for="tiPublishStatus"> منتشر شده </label>
        
        </div>

        <!-- نردبان -->

        <div class="form-check form-switch m-0 d-flex align-items-center col-6 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bVIP" formControlName="bVIP">
        
            <label class="form-check-label pointer text-muted me-2" for="bVIP"> نردبان </label>
        
        </div>

        <!-- افزودن آگهی -->

        <div class="col-12 col-md-auto d-flex align-items-center">

            <button class="btn btn-primary w-100" (click)="new_Ads()"> افزودن آگهی </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto d-flex align-items-center">

            <button class="btn btn-success w-100" (click)="exportexcel('Export_Excel')"> خروجی اکسل </button>

        </div>

        <!-- جدول اطلاعات -->

        <div class="section border border-2 mt-2">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
            
                    <tr class="text-center">
        
                        <th scope="col" class="">#</th>

                        <th scope="col" class=""> عملیات </th>

                        <th scope="col" class="pointer"> کد </th>

                        <th scope="col" class=""> وضعیت </th>

                        <th scope="col" class="pointer"> عنوان </th>
    
                        <th scope="col" class=""> تاریخ ثبت </th>
    
                        <th scope="col" class=""> موبایل </th>
    
                        <th scope="col" class="pointer"> نوع خودرو </th>
                        
                        <th scope="col" class="pointer"> نام خودرو </th>
    
                        <th scope="col" class="pointer"> نردبان </th>
    
                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="f14 text-center" *ngFor="let item of lst_Ads;let i=index">

                        <th class="text-dark">{{ i + 1 | faNum }}</th>

                        <th class="">
                        
                            <i class="text-danger fa fa-trash fa-lg pointer" (click)="removeAds(item,i)"></i>

                            <i class="text-primary mx-2 fa fa-pencil-square-o fa-lg pointer" (click)="new_Ads(true,item,i)"></i>

                            <i class="text-dark fa fa-file-image-o fa-lg pointer" (click)="openGallery(item)"></i>
                        
                        </th>

                        <td> {{ item.iTaxilon_Advertisement | faNum }} </td>

                        <td> {{ item.strPublishStatus | faNum }} </td>

                        <td> {{ item.strTitle | faNum }} </td>

                        <td> {{ item.strSaveDate | faNum }} </td>

                        <td> {{ item.strMobile | faNum }} </td>

                        <td> {{ item.strMobileType_strComment | faNum }} </td>

                        <td> {{ item.strGPSType_strComment | faNum }} </td>

                        <td> {{ item.bVIP ? '✅' : '❌' }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- افزودن و ویرایش -->

<div class="modal fade" id="Ads_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg modal-fullscreen-sm-down">

        <div class="modal-content" style="direction: rtl;">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMode ? 'ویرایش آگهی' : 'افزودن آگهی' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div [formGroup]="mdl_Ads" class="modal-body">

                <div class="row gx-2 gy-1 p-2">

                    <!-- عنوان -->
                    
                    <div class="col-12 position-relative p-2">

                        <label class="mb-2 text-muted"> * عنوان </label>

                        <input class="form-control p-2 text-center" formControlName="strTitle">

                    </div>

                    <!-- نوع -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> * نوع </label>
            
                        <select class="form-select p-2" formControlName="tiType">
            
                            <option class="text-center" [value]="-1"> انتخاب کنید </option>

                            <option class="text-center" *ngFor="let item of lst_tiType" [value]="item.tiType">
                                
                                {{item.strComment}}
                            
                            </option>

                        </select>
            
                    </div>
                    
                    <!-- شهر -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> * شهر </label>

                        <custom-filter *ngIf="showFilter"

                            [strValue]="returnStrValue('strCity', mdl_Ads.get('strCity')?.value,lst_City,'strCityName')"
                    
                            [strComment]="'strCityName'"
                    
                            [stylesArray]="['padding-top: 10px','text-align: start']"
                    
                            [str_Placeholder]="' جستجو کنید...'"
                    
                            [lst_Main]="lst_City" 
                    
                            [lst_SearchKey]="['strCityName']"
                    
                            [isDisabled]="mdl_Ads.disabled || isCity ? true : false"
                            
                            (hideOptions)="mdl_Ads.get('strCity')?.setValue($event?.strCity ? $event.strCity : '')">
            
                        </custom-filter>


                    </div>

                    <!-- موبایل -->
                    
                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> * موبایل </label>

                        <input class="form-control p-2 text-center"

                            oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                        
                            formControlName="strMobile">

                    </div>

                    <!-- نوع خودرو -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> * نوع خودرو </label>

                        <select class="form-select p-2" formControlName="tiMobileType">

                            <option class="text-center" [value]="-1"> انتخاب کنید </option>

                            <option class="text-center" *ngFor="let item of carWork" value="{{item.tiMobileType}}">

                                {{item.strComment}}

                            </option>

                        </select>

                    </div>

                    <!-- نام خودرو -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> * نام خودرو </label>

                        <select class="form-select p-2" formControlName="tiGPSType">

                            <option class="text-center" [value]="-1"> انتخاب کنید </option>

                            <option class="text-center" *ngFor="let item of carType" [value]="item.tiGPSType">

                                {{item.strComment}}

                            </option>

                        </select>

                    </div>

                    <!-- تیپ خودرو -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> تیپ خودرو </label>

                        <input class="form-control p-2 text-center" formControlName="strVehicleType">

                    </div>

                    <!-- رنگ خودرو -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> رنگ خودرو </label>

                        <input class="form-control p-2 text-center" formControlName="strColor">

                    </div>

                    <!-- سال ساخت -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> سال ساخت </label>

                        <input class="form-control p-2 text-center" formControlName="strYearConstraction">

                    </div>

                    <!-- ظرفیت -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> ظرفیت </label>

                        <input class="form-control p-2 text-center" formControlName="strPassenger">

                    </div>

                    <!-- آماده به کار از تاریخ -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> از تاریخ  </label>
            
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
            
                            <input type="text" formControlName="strSDate" class="form-control text-end"/>
            
                        </ng-persian-datepicker>
            
                    </div>

                    <!-- آماده به کار تا تاریخ -->

                    <div class="col-12 col-md-4 position-relative p-2">

                        <label class="mb-2 text-muted"> تا تاریخ  </label>
            
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
            
                            <input type="text" formControlName="strEDate" class="form-control text-end"/>
            
                        </ng-persian-datepicker>
            
                    </div>

                    <!-- ساعت شروع -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted" style="z-index: 10;"> ساعت شروع </label>
                
                        <div class="input-group clockpicker">
                
                            <input type="text" class="form-control p-2 text-center" id="STime" formControlName="strSTime">
                
                            <span class="input-group-addon">
                
                                <span class="glyphicon glyphicon-time"></span>
                
                            </span>
                
                        </div>
                
                    </div>

                    <!-- ساعت پایان -->

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted" style="z-index: 10;"> ساعت پایان </label>
                
                        <div class="input-group clockpicker">
                
                            <input type="text" class="form-control p-2 text-center" id="ETime" formControlName="strETime">
                
                            <span class="input-group-addon">
                
                                <span class="glyphicon glyphicon-time"></span>
                
                            </span>
                
                        </div>
                
                    </div>

                    <!-- ساعتی -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bHourly" formControlName="bHourly">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bHourly"> ساعتی </label>
                    
                    </div>
                    
                    <!-- نرخ ساعتی -->

                    <ng-container *ngIf="mdl_Ads.get('bHourly')?.value">
                    
                        <div class="col-12 col-md-12 position-relative p-2">

                            <label class="mb-2 text-muted"> نرخ ساعتی(ریال) </label>

                            <input class="form-control p-2 text-center" formControlName="iHourlyRent">

                        </div>

                    </ng-container>

                    <!-- ماهیانه -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bMonthly" formControlName="bMonthly">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bMonthly"> ماهیانه </label>
                    
                    </div>
                    
                    <!-- نرخ ماهیانه -->

                    <ng-container *ngIf="mdl_Ads.get('bMonthly')?.value">
                    
                        <div class="col-12 col-md-12 position-relative p-2">

                            <label class="mb-2 text-muted"> نرخ ماهیانه(ریال) </label>

                            <input class="form-control p-2 text-center" formControlName="iMonthlyRent">

                        </div>

                    </ng-container>
                    
                    <!-- کلید در اختیار -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bKeyInHand" formControlName="bKeyInHand">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bKeyInHand"> کلید در اختیار </label>
                    
                    </div>

                    <!-- نرخ کلید در اختیار -->

                    <ng-container *ngIf="mdl_Ads.get('bKeyInHand')?.value">
                    
                        <div class="col-12 col-md-12 position-relative p-2">

                            <label class="mb-2 text-muted"> نرخ کلید در اختیار(ریال) </label>

                            <input class="form-control p-2 text-center" formControlName="iKeyInHandRent">

                        </div>

                    </ng-container>
                                        
                    <!-- نردبان -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bVIP" formControlName="bVIP">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bVIP"> نردبان </label>
                    
                    </div>

                    <!-- توضیحات -->

                    <div class="position-relative col-12 p-2 mt-3">

                        <label class="mb-2 text-muted"> توضیحات </label>

                        <textarea style="resize: none;height: 150px;" class="form-control" formControlName="strComment"></textarea>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn" [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' " (click)="submitAds()">

                    &nbsp; {{ bEditMode ? 'ویرایش' : 'ذخیره' }} &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- لیست تصاویر آگهی -->

<div class="modal fade" id="Gallery_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content" style="direction: rtl;">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> تصاویر آگهی </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="row gx-2 gy-2 p-3">

                    <div class="col-12 mb-2 p-2 d-flex flex-column align-items-center border border-2 rounded">

                        <img width="100px" height="100px" src="../../../assets/Img/post.png"  alt="آپلود تسویر آگهی">

                        <p class="my-2"> 
                            
                            تصویر خود را 
                            
                                <span class="text-primary pointer" (click)="fileInput.click()" >از اینجا</span>
                            
                            انتخاب کنید.

                            <input hidden type="file" #fileInput (change)="onFileInput($event.target.files[0]);" />
                        
                        </p>

                    </div>

                    <ng-container *ngFor="let item of lst_Upload;let i=index">

                        <div class="thumbnail col-md-3 col-12 p-2">

                            <div class="position-relative w-100 h-100 pointer">
                                
                                <img width="100%" height="100%" src="{{'data:image/jpeg;base64,' + item.strImage}}">

                                <div class="thumbnail-remove d-none" (click)="remove_Thumbnail(item,i)">

                                    <i class="fa fa-trash fa-2x text-danger" aria-hidden="true"></i>

                                </div>

                            </div>

                        </div>

                    </ng-container>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>
